(function(global, factory) {
    typeof exports === "object" && typeof module !== "undefined" ? factory() : typeof define === "function" && define.amd ? define(factory) : factory();
})(this, function() {
    "use strict";
    
    /*  js errors: desktop view is loading incorrectly */ 
    function toggleMenu(header, html) {
        header.classList.toggle("open");
        html.classList.toggle("noscroll");
    }
    function toggleDropdowns(e, item) {
        if (window.innerWidth < 960) {
            e.preventDefault();
            item.parentElement.classList.toggle("sub-menu-open");
        }
    }
var navigation = function() {
    var header = document.getElementById("masthead");
    var menuButton = document.getElementById("menu-btn");
    var html = document.getElementById("html");

    if (!header) return;

    var dropdowns = Array.from(header.querySelectorAll(".menu-item-has-children > a"));

    if (menuButton) {
        menuButton.addEventListener("click", function() {
            toggleMenu(header, html);
        });
    }

    if (dropdowns.length && window.innerWidth < 960) {
        dropdowns.forEach(function(item) {
            var listItem = document.createElement("li");
            var cloneTopLink = item.cloneNode(true);
            listItem.appendChild(cloneTopLink);

            var subMenu = item.parentElement.querySelector(".sub-menu");
            if (subMenu) {
                subMenu.prepend(listItem); // phpcs:ignore WordPressVIPMinimum.JS.HTMLExecutingFunctions.prepend -- DOM node, not raw HTML
            }

            item.addEventListener("click", function(e) {
                toggleDropdowns(e, item);
            });
        });
    }
};
    var video = function(video) {
        video.forEach(function(v) {
            var iframe = v.querySelector(".video-embed");
            var placeholder = v.querySelector(".video-placeholder");
            var buttons = v.querySelectorAll(".place-click");
            buttons.forEach(function(button) {
                button.addEventListener("click", function(e) {
                    e.preventDefault();
                    iframe.classList.add("show");
                    placeholder.classList.add("hide");
                });
            });
        });
    };
    window.addEventListener("load", function() {
        navigation();
        var wpVideo = Array.from(document.querySelectorAll(".featured-video"));
        if (wpVideo.length > 0) {
            video(wpVideo);
        }
    });

});


// Add your custom JS here.
(function($){
  $(document).ready( function() {
  


    if ( jQuery('.supertrak-hero-slider.slider-type1 .slider-wrp').length) {
      jQuery('.supertrak-hero-slider.slider-type1 .slider-wrp').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          infinite: true,
          arrows: true,
          dots: true,
          fade: true,
          cssEase: 'linear'
      });
  }
  if ( jQuery('.supertrak-hero-slider.slider-type4 .slider-wrp').length) {
      jQuery('.supertrak-hero-slider.slider-type4 .slider-wrp').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          infinite: true,
          arrows: true,
          dots: true,
          fade: true,
          cssEase: 'linear'
      });
  }
  if ( jQuery('.supertrak-hero-slider.slider-type2 .slider-wrp').length) {
      jQuery('.supertrak-hero-slider.slider-type2 .slider-wrp').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          infinite: true,
          arrows: false,
          dots: true,
          fade: true,
          cssEase: 'linear'
      });
  }
  if ( jQuery('.supertrak-hero-slider.slider-type3 .slider-wrp').length) {
      jQuery('.supertrak-hero-slider.slider-type3 .slider-wrp').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          infinite: true,
          arrows: false,
          dots: false,
          fade: true,
          cssEase: 'linear'
      });
  }

  if ( jQuery('.trakmaster-integrated-functionality-slider').length) {
     jQuery('.trakmaster-integrated-functionality-slider').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 3000,
          infinite: true,
          arrows: true,
          dots: false,
          responsive: [{
              breakpoint: 992,
                  settings: {
                      slidesToShow: 3
                  }
          },  {
              breakpoint: 768,
              settings: {
                  slidesToShow: 2
              }
          }, {
              breakpoint: 576,
              settings: {
                  slidesToShow: 1
              }
          }]
      });  
  } 

  // st-home-slider
  if ( $('.st-home-slider > .gb-inside-container').length) {
      $('.st-home-slider > .gb-inside-container').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 5000,
          fade: true,
          infinite: true,
          arrows: false,
          dots: true,
      }); 
  } 


  jQuery('.trakmaster-system-simulations .readmore-btn').click(function() {
      if ( jQuery(this).hasClass('hidden') ) {
          jQuery(this).parent().parent().find('.hidden-paragraph').addClass('hidden');
          jQuery(this).removeClass('hidden');
      } else {
          jQuery(this).parent().parent().find('.hidden-paragraph').removeClass('hidden');
          jQuery(this).addClass('hidden');
      }
    
  }); 

  jQuery('.icon-item.hover-effect .readmore-btn').click(function() {
      if ( jQuery(this).hasClass('hidden') ) {
          jQuery(this).parent().parent().find('.hidden-paragraph').addClass('hide-text');
          jQuery(this).removeClass('hidden');
      } else {
          jQuery(this).parent().parent().find('.hidden-paragraph').removeClass('hide-text');
          jQuery(this).addClass('hidden');
      }
    
  }); 

  jQuery('.trakmaster-video-section .video-play').click(function() {
      jQuery('.trakmaster-video-section .video-modal').addClass('modal-show');
  });

  jQuery('.trakmaster-video-section .video-modal .close-x').click(function() {
      jQuery('.trakmaster-video-section .video-modal').removeClass('modal-show');
  });

  // iframe auto height
  if ( jQuery('#pardot-form-iframe').length ) {
    jQuery('#pardot-form-iframe').seamless({
      fallbackText: ''
    });
  }

  // UTM parameters
  var current_url = window.location.href; // phpcs:ignore WordPressVIPMinimum.JS.Window.VarAssignment -- used for URL parsing, not output

  var current_url_array = current_url.split('?');

  if ( current_url_array.length >= 2 ) {

    var query_parameters = current_url.slice(current_url.indexOf("?") + 1);

    var query_parameters_array = query_parameters.split('&');
    var new_query_parameters = '';

    for (let i = 0; i < query_parameters_array.length; i++) {
      if ( query_parameters_array[i].includes('utm')  ) {
        if ( new_query_parameters.length > 0 ) {
          new_query_parameters += '&' + query_parameters_array[i];
        } else {
          new_query_parameters += query_parameters_array[i];
        }
        
      }
    }

    if ( new_query_parameters.length > 0 ) {

      jQuery('body a').each(function() {
        var href = jQuery(this).attr('href');
        if ( href != '' && href != 'javascript:;' && href != '#' ) {
          href = href + '?' + new_query_parameters;
        }
        jQuery(this).attr('href', href);
      });
    }
  }

  jQuery('.atsls-innovation-tab .tab-item').click(function() {
    var data_tab = jQuery(this).attr('data-tab');

    jQuery('.atsls-innovation-tab .tab-item').removeClass('active');
    jQuery(this).addClass('active');

    jQuery('.atsls-innovation-tab .tab-content').removeClass('active');
    jQuery('.atsls-innovation-tab .tab-content[data-tab=' + data_tab + ']').addClass('active');
  });

  jQuery(document).on("scroll", function () {
    if (jQuery('.atsco-culture-section').length) {
      jQuery('.atsco-culture-section .culture-item').each(function () {
        if (jQuery(document).scrollTop() < jQuery(this).offset().top - 150) {
          var data_title = jQuery(this).attr('data-title');
          jQuery('.culture-sidebar h3').removeClass('active');
          jQuery('.culture-sidebar h3[data-title="' + data_title + '"]').addClass('active');
          return false;
        }
      });
    }
  });
  jQuery('.culture-sidebar h3').click(function () {
    var data_title = jQuery(this).attr('data-title');
    jQuery('.atsco-culture-section .culture-item').each(function () {
      if (data_title == jQuery(this).attr('data-title')) {
        jQuery('html, body').animate({
          scrollTop: jQuery(this).offset().top - 200
        }, 500);
      }
    });
  });

  // st modal
  $('.st-modal').each(function() {
    $(this).find('.gb-inside-container').append('<div class="close-btn"></div>');
  });

  $('.st-modal-btn').click(function() {
    var data_id = $(this).attr('data-id');

    if ($('.st-modal[data-id="' + data_id + '"]').length) {
      $('.st-modal[data-id="' + data_id + '"]').addClass('modal-show');
    }
    return false;
  });

// Close modal by close button
$('.st-modal .gb-inside-container .close-btn').click(function() {

  const $modal = $(this).closest('.st-modal');

  $modal.removeClass('modal-show');

  // Reset iframe videos
  const $iframe = $modal.find('iframe');
  $iframe.each(function() {
      const src = $(this).attr('src');
      $(this).attr('src', src);
  });

  // Reset HTML5 video
  const $video = $modal.find('video');
  $video.each(function() {
      try {
          this.pause();
          this.currentTime = 0;
      } catch(e){}
  });
});


// Close modal by clicking outside
window.addEventListener('click', function(e){   

  $('.st-modal').each(function() {

      const $modal = $(this);
      const data_id = $modal.attr('data-id');
      const $btn = $('.st-modal-btn[data-id="' + data_id + '"]')[0];

      if ($modal.hasClass('modal-show') && (!$btn || !$btn.contains(e.target))) {

          if ($modal.find('.gb-inside-container')[0].contains(e.target)) {
          } else {

              $modal.removeClass('modal-show');

              const $iframe = $modal.find('iframe');
              $iframe.each(function() {
                  const src = $(this).attr('src');
                  $(this).attr('src', src);
              });

              const $video = $modal.find('video');
              $video.each(function() {
                  try {
                      this.pause();
                      this.currentTime = 0;
                  } catch(e){}
              });
          }
      }

  });
});


  // Header Menu
  if ($(window).width() >= 1230) {
    $('.site-header__menu-main .menu > .menu-item.menu-item-has-children > a').click(function(e) {
      e.preventDefault();

      var $link = $(this);
      var $item = $link.parent('.menu-item-has-children');
      var $submenu = $item.children('.sub-menu');

      $('.site-header__menu-main .menu > .menu-item.menu-item-has-children.open').not($item).each(function() {
        $(this).removeClass('open').children('.sub-menu').css('height', 0);
      });

      if ($item.hasClass('open')) {
        $submenu.css('height', 0);
        $item.removeClass('open');
      } else {
        var fullHeight = $submenu.prop('scrollHeight') + 'px';
        $submenu.css('height', fullHeight);
        $item.addClass('open');
      }
    });
  }

  // Mobile Menu Toggle
  const menuToggle = document.querySelector('.hamburger-menu-toggle input');
  const mobileMenu = document.querySelector('.mobile-menu');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('change', function () {
      if (menuToggle.checked) {
        mobileMenu.classList.add('menu-show');
        mobileMenu.classList.remove('menu-hide');
      } else {
        mobileMenu.classList.remove('menu-show');
        mobileMenu.classList.add('menu-hide');
      }
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth >= 1200) {
        mobileMenu.classList.remove('menu-show', 'menu-hide');
        menuToggle.checked = false;
      }
    });
  }

  // Mobile Dropdown Toggle - add icon and toggle submenu on icon click only
  $('.mobile-menu-wrp .menu .menu-item-has-children').each(function() {
    const $item = $(this);
    const $link = $item.children('a');
    const $submenu = $item.children('.sub-menu');
    const $parentEl = $item.parent('.menu-item');

    // Create toggle icon
    const $toggle = $('<span class="submenu-toggle"></span>'); 

    $link.after($toggle); // phpcs:ignore WordPressVIPMinimum.JS.HTMLExecutingFunctions.after -- hardcoded markup, no user data

    $toggle.on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      $submenu.toggleClass('open');
      $parentEl.toggleClass('open')
    });
  });


  function initMainSlider(){
    // Main Slider
    const $mainSlider = $('.slider-banner-main');
    const $navWrapper = $('.slider-banner-nav-wrp');
    const $navSlides = $navWrapper.find('.slider-banner-nav-slide');

    if ($navSlides.length <= 1) {
      return;
    }
    $mainSlider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      autoplay: true,
      autoplaySpeed: 8000,
      infinite: true,
    });

    if ($navSlides.length > 4) {
      $navWrapper.slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        asNavFor: '.slider-banner-main',
        focusOnSelect: true,
        variableWidth: false,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 8000,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
      $mainSlider.slick('slickSetOption', 'asNavFor', '.slider-banner-nav-wrp', true);

      $navWrapper.on('click', '.slick-slide', function () {
        const index = $(this).data('slick-index');
        if (typeof index !== 'undefined') {
          $mainSlider.slick('slickGoTo', index);
        }
      });
    } else {
      if (window.innerWidth <= 1024) {
        $navWrapper.slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          asNavFor: '.slider-banner-main',
          focusOnSelect: true,
          variableWidth: false,
          arrows: true,
          autoplay: true,
          autoplaySpeed: 8000,
          responsive: [
            
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
        $mainSlider.slick('slickSetOption', 'asNavFor', '.slider-banner-nav-wrp', true);
      } else {
        $navWrapper.addClass('elem-block');
        const $underline = $('<div class="slider-banner-nav-underline"></div>');
        const $prevBtn = $('<button class="slider-banner-nav-prev"></button>');
        const $nextBtn = $('<button class="slider-banner-nav-next"></button>');
        $navWrapper.append($underline, $prevBtn, $nextBtn); // phpcs:ignore WordPressVIPMinimum.JS.HTMLExecutingFunctions.append -- hardcoded markup, no user data

        function updateUnderline($el) {
          if (!$el.length) return;
          $underline.css({
            width: $el.outerWidth() - 50,
            left: $el.position().left + 25
          });
        }

        let currentIndex = 0;

        function goTo(index) {
          currentIndex = index;
          $mainSlider.slick('slickGoTo', index);
          $navSlides.removeClass('slick-current');
          $navSlides.eq(index).addClass('slick-current');
          updateUnderline($navSlides.eq(index));
        }

        $navSlides.each(function(index) {
          $(this).on('click', function() {
            goTo(index);
          });
        });

        $prevBtn.on('click', function() {
          const newIndex = (currentIndex - 1 + $navSlides.length) % $navSlides.length;
          goTo(newIndex);
        });

        $nextBtn.on('click', function() {
          const newIndex = (currentIndex + 1) % $navSlides.length;
          goTo(newIndex);
        });

        goTo(0);
      }
    }
  }

  initMainSlider();
  

  // Add beforeChange event handler for .slider-banner
  $('.slider-banner').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      const $navSlides = $('.slider-banner-nav-slide');
      const $underline = $('.slider-banner-nav-underline');

      if ($navSlides.length <= 4) {
          $navSlides.removeClass('slick-current');
          const $nextNavSlide = $navSlides.eq(nextSlide);
          $nextNavSlide.addClass('slick-current');

          const slideWidth = $nextNavSlide.outerWidth();
          const slideLeft = $nextNavSlide.position().left;

          $underline.css({
              width: slideWidth - 25,
              left: slideLeft + 25
          });
      }
  });

if ($('.ats-accordion-toggle').length) {
    $('.ats-accordion-toggle').each(function () {
      const $toggle = $(this);
      const $title = $toggle.find('.title');
      const $content = $toggle.find('.content');

      if ($title.length && !$title.find('span').length) {
        const span = document.createElement('span');
        while ($title[0].firstChild) {
          span.appendChild($title[0].firstChild);
        }
        $title[0].appendChild(span);
      }

      $title.on('click', function () {
        $content.stop(true, true);
        if ($toggle.hasClass('is-open')) {
          $content.slideUp(300);
          $toggle.removeClass('is-open');
        } else {
          $content.slideDown(300);
          $toggle.addClass('is-open');
        }
      });
    });
  }



  $(document).on('click', '.modal-btn', function(e){
    e.preventDefault();

    const target = $(this).data('modal');
    const $modal = $('.ats-modal[data-modal="' + target + '"]');

    if ($modal.length) {
        $modal.addClass('open');
    }
  });

  $(document).on('click', '.ats-modal .close', function(){
    $(this).closest('.modal').removeClass('open');
  });




  $('.timeline-slider').each(function () {

    const $wrapper = $(this);
  
    const $topSlider = $wrapper.find('.timeline-slider__top .swiper-wrapper');
    const $bottomSlider = $wrapper.find('.timeline-slider__bottom .swiper-wrapper');
  
    if (!$topSlider.length || !$bottomSlider.length) {
      return;
    }
  
    $topSlider.slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      asNavFor: $bottomSlider,
      speed: 400,
      draggable: true,
      swipe: true,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 2 } },
        { breakpoint: 767, settings: { slidesToShow: 1 } }
      ]
    });
  
    $bottomSlider.slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      asNavFor: $topSlider,
      focusOnSelect: true,
      arrows: false,
      speed: 400,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 2 } },
        { breakpoint: 767, settings: { slidesToShow: 1 } }
      ]
    });
  
    $bottomSlider.on('click', '.slick-slide', function () {
      const index = $(this).data('slick-index');
      $topSlider.slick('slickGoTo', index);
    });
  
    $wrapper.find('.timeline-slider__play').on('click', function () {
      const $btn = $(this);
      const $wrp = $btn.closest('.timeline-slider__video-wrp');
      const video = $wrp.find('video')[0];
      const iframe = $wrp.find('iframe')[0];
  
      $btn.hide();
  
      if (video) {
        video.setAttribute('controls', '');
        video.play();
        return;
      }
  
      if (iframe) {
        iframe.classList.remove('timeline-slider__youtube--no-pointer');
  
        let src = iframe.getAttribute('src') || '';
        src = src.replace(/controls=0/, 'controls=1');
  
        if (!/autoplay=1/.test(src)) {
          src += (src.includes('?') ? '&' : '?') + 'autoplay=1';
        }
  
        iframe.setAttribute('src', src);
      }
    });
  
    $topSlider.on('beforeChange', function () {
  
      $wrapper.find('video').each(function () {
        try {
          this.pause();
          this.currentTime = 0;
          this.removeAttribute('controls');
        } catch(e){}
      });

      $wrapper.find('iframe').each(function () {
        const iframe = this;
        if (iframe.classList.contains('timeline-slider__youtube--no-pointer')) {
          return;
        }
        let src = iframe.getAttribute('src') || '';
        src = src.replace(/autoplay=1/, 'autoplay=0');
        src = src.replace(/controls=1/, 'controls=0');
        iframe.setAttribute('src', src);
        iframe.classList.add('timeline-slider__youtube--no-pointer');
      });

      $wrapper.find('.timeline-slider__play').show();
    });
  
  });


  if ($('.accordion-block').length) {

    $('.accordion-block.first-open').each(function() {
      const $firstElem = $(this).find('.each-elem').first();
      $firstElem.addClass('active');
      $firstElem.find('.content').show();
      $firstElem.find('.title').addClass('open');
    });
  
    $('.accordion-block .title').on('click', function() {
      const $title = $(this);
      const $item = $title.closest('.each-elem');
      const $content = $item.find('.content');
  
      $content.stop(true, true).slideToggle();
      $title.toggleClass('open');
      $item.toggleClass('active');
    });
  
  }
  

  function initAnchorScroll(offset) {
    $(document).on('click', 'a[href^="#"]', function (e) {
      const id = $(this).attr('href');
      if (!id || id === '#') return;
  
      const $target = $(id);
      if (!$target.length) return;
  
      e.preventDefault();
  
      $('html, body').stop().animate({
        scrollTop: $target.offset().top - offset
      }, 500);
  
      history.pushState(null, '', id);
    });
  }

  initAnchorScroll(150);

  function initScrollSpy(navSelector, offset) {
    const $nav = $(navSelector);
    if (!$nav.length) return;

    const $navLinks = $nav.find('a[href^="#"]');
    if (!$navLinks.length) return;

    const sections = [];
    $navLinks.each(function () {
      const href = $(this).attr('href');
      try {
        const $section = $(href);
        if ($section.length) {
          sections.push({ link: $(this), target: $section });
        }
      } catch (e) { /* invalid selector */ }
    });

    if (!sections.length) return;

    function setActive(index) {
      $navLinks.removeClass('active');
      sections[index].link.addClass('active');
    }

    $(window).on('scroll', function () {
      const scrollTop = $(window).scrollTop() + offset;
      let currentIndex = 0;

      for (let i = 0; i < sections.length; i++) {
        if (sections[i].target.offset().top <= scrollTop) {
          currentIndex = i;
        }
      }

      setActive(currentIndex);
    });

    $(window).trigger('scroll');
  }

  initScrollSpy('.js-scroll-spy', 200);

  function wrapTableTextInSpan() {

    const $table = $('.parts-list-table');

    if (!$table.length) {
      return;
    }

    $table.find('td, th').each(function () {
      const $cell = $(this);

      if ($cell.find('span').length) {
        return;
      }

      $cell.contents().each(function () {
        if (this.nodeType === Node.TEXT_NODE && this.nodeValue.trim() !== '') {
          $(this).wrap('<span></span>');
        }
      });
    });
  }

  wrapTableTextInSpan();

  $('.video').on('click', function () {
    const $this = $(this);
    const video = $this.find('video')[0];
    if (video && video.paused) {
      video.play();
      video.setAttribute('controls', 'controls');
      $this.removeClass('video');
    }
  });

  if ($('.basic-slider').length) {
    $('.basic-slider').each(function () {
      const $slider = $(this);
      const slidesDesktop = parseInt($slider.attr('data-slides'), 10) || 3;
  
      $slider.slick({
        slidesToShow: slidesDesktop,
        slidesToScroll: 1,
        autoplay: false,
        infinite: true,
        arrows: true,
        dots: false,
        responsive: [
          {
            breakpoint: 992,
            settings: { slidesToShow: 2 }
          },
          {
            breakpoint: 768,
            settings: { slidesToShow: 1 }
          }
        ]
      });
    });
  }

  // end script
  });

})(jQuery);
